import {
  Clock,
  Waves,
  UtensilsCrossed,
  Sparkles,
  Dumbbell,
  Users,
  ShieldCheck,
  Music,
} from "lucide-react";
import ResortTemplate from "@/components/ResortTemplate";
import heroMuroAlto1 from "@/assets/hero-muro-alto-1.jpg";
import heroMuroAlto2 from "@/assets/hero-muro-alto-2.jpg";
import heroMuroAlto3 from "@/assets/hero-muro-alto-3.jpg";
import heroMuroAlto4 from "@/assets/hero-muro-alto-4.jpg";
import heroMuroAlto5 from "@/assets/hero-muro-alto-5.jpg";
import resortInfra from "@/assets/resort-infrastructure.jpg";
import piscinasNaturais from "@/assets/piscinas-naturais.jpg";

const Porto2Life = () => {
  return (
    <ResortTemplate
      developmentSlug="porto-2-life"
      name="Porto 2 Life"
      location="Muro Alto · Porto de Galinhas, PE"
      highlightLabel="Resort em Destaque"
      heroImage={heroMuroAlto1}
      heroDescription="Um refúgio à beira-mar em Muro Alto com piscinas de borda infinita, gastronomia inesquecível e a natureza preservada das piscinas naturais de Porto de Galinhas."
      rating={{ value: "4.9", reviews: "+1.200 avaliações de hóspedes" }}
      primaryCtaTo="/busca?empreendimento=Porto%202%20Life"
      about={{
        eyebrow: "Sobre o Resort",
        title: "Conforto, natureza e exclusividade em um só lugar",
        paragraphs: [
          "Localizado a poucos passos das famosas piscinas naturais de Porto de Galinhas, o Porto 2 Life combina arquitetura moderna, áreas de lazer completas e atendimento personalizado para garantir momentos inesquecíveis em família, casal ou com amigos.",
          "Com apartamentos amplos e totalmente equipados, gastronomia regional refinada e equipe atenciosa 24h, oferecemos uma experiência completa para quem busca descanso com requinte.",
        ],
        image: resortInfra,
        imageAlt: "Porto 2 Life — vista do resort",
        stats: [
          { value: "120+", label: "Suítes" },
          { value: "5", label: "Piscinas" },
          { value: "24/7", label: "Concierge" },
        ],
      }}
      gallery={{
        title: "Cada detalhe pensado para encantar",
        description:
          "Explore os ambientes que tornam o Porto 2 Life uma experiência única — do nascer do sol nas piscinas naturais ao jantar sob as estrelas.",
        items: [
          { src: heroMuroAlto1, alt: "Piscina de borda infinita com vista para o mar", span: "big" },
          { src: piscinasNaturais, alt: "Piscinas naturais de Muro Alto" },
          { src: heroMuroAlto2, alt: "Suíte com varanda e vista para o oceano" },
          { src: heroMuroAlto3, alt: "Restaurante com pôr do sol", span: "wide" },
          { src: heroMuroAlto4, alt: "Spa & bem-estar" },
          { src: heroMuroAlto5, alt: "Praia exclusiva de Muro Alto" },
        ],
      }}
      features={{
        title: "Tudo o que você precisa em um único lugar",
        description:
          "O maior empreendimento da GAV Resorts em Muro Alto entrega comodidades pensadas do check-in ao check-out.",
        items: [
          {
            icon: Clock,
            title: "Atendimento 24h",
            description: "Recepção 24h, concierge e equipe dedicada para apoiar sua estadia a qualquer momento.",
          },
          {
            icon: Waves,
            title: "Piscinas & Toboágua",
            description: "Piscinas de borda infinita, prainha infantil, toboágua e acesso direto às piscinas naturais.",
          },
          {
            icon: UtensilsCrossed,
            title: "Gastronomia Premium",
            description: "Restaurante japonês inédito, pâtisserie exclusiva e bar à beira-mar.",
          },
          {
            icon: Sparkles,
            title: "Wellness & Saunas",
            description: "Saunas com vista panorâmica, áreas de relaxamento e tratamentos exclusivos.",
          },
          {
            icon: Dumbbell,
            title: "Quadras & Esportes",
            description: "Quadras poliesportiva, de areia e tênis, além de esportes aquáticos e atividades guiadas.",
          },
          {
            icon: Users,
            title: "Para Toda Família",
            description: "Salão de jogos, minigolfe, kids club e programação para todas as idades.",
          },
          {
            icon: Music,
            title: "Entretenimento",
            description: "Karaokê, palco aquático e shows ao vivo para tornar suas noites inesquecíveis.",
          },
          {
            icon: ShieldCheck,
            title: "Segurança & Estacionamento",
            description: "Estacionamento gratuito, acesso controlado e monitoramento 24h.",
          },
        ],
      }}
      location_section={{
        title: "A poucos passos do paraíso",
        description:
          "Em frente às famosas piscinas naturais de Muro Alto, com fácil acesso aos principais pontos turísticos de Porto de Galinhas.",
        contact: {
          address: "Praia de Muro Alto, Porto de Galinhas — Ipojuca, PE · CEP 55590-000",
          cityState: "Porto de Galinhas, PE",
          phone: "+55 (81) 3552-0000",
          travelInfo: "50 km do Aeroporto do Recife (REC) — cerca de 50 min de carro.",
          mapEmbedUrl:
            "https://www.google.com/maps?q=-8.419796985795106,-34.97438954480893&hl=pt-BR&z=15&output=embed",
          directionsUrl:
            "https://www.google.com/maps/dir/?api=1&destination=Praia%20de%20Muro%20Alto%2C%20Porto%20de%20Galinhas%20-%20PE",
        },
      }}
    />
  );
};

export default Porto2Life;
